import { Article } from './Article';
import { DynamicComms, EstimatedDeliveryDateRange, Merchant, Notice } from './Payload';

/**
 * Shipment information as used by Track UI.
 *
 * Usually transformed from a Shipment API payload.
 */
export interface Shipment {
  consignmentId: string;
  articles: Article[];
  carbonNeutral: boolean | null;
  dynamicComms?: DynamicComms | null;
  dynamicCommsList?: Notice[] | null;
  merchant?: Merchant | null;
}

export interface CalculatedDelivery {
  onDate?: string;
  expectedBetween?: EstimatedDeliveryDateRange;
}

export enum FlightStatus {
  ON_TIME = 'On time',
  UPDATED = 'Updated',
  LATE = 'Late',
  EXPECTED_TODAY = 'Expected Today',
}
